<template>
  <div class="card">
    <div class="card-header">
      <div class="card-title">
        <p>{{ street }} {{ number }}</p>
        <p>{{ buildingData.postal_code }} {{ buildingData.city.name }}</p>
      </div>
      <div class="card-menu">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template #button-content>
            <b-icon icon="three-dots-vertical"></b-icon>
          </template>
          <b-dropdown-item class="dropdown-item-zone" href="#" @click="openDeclarationModal('A')">
            Dodaj Deklarację A
          </b-dropdown-item>
          <b-dropdown-item class="dropdown-item-zone" href="#" @click="openDeclarationModal('B')">
            Dodaj Deklarację B
          </b-dropdown-item>
          <b-dropdown-item class="dropdown-item-zone" href="#" @click="openEditBuildingModal" v-if="!anyDeclarationWasAdded(buildingData)">
            Edytuj Budynek
          </b-dropdown-item>
          <b-dropdown-item class="dropdown-item-zone" href="#" @click="openDeleteModal">
            Usuń Budynek
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <div class="card-body">
      <img
          src="https://ceeb-devel.azurewebsites.net/staticfiles/img/city_a.png"
          class="card-image"/>
      <p class="building-type-label">Rodzaj budynku:</p>

      <div class="bottom-text">
        <div class="letter-icon first-icon">
          A
        </div>
        <p class="bottom-text-title">Budynek / lokal mieszkalny</p>
        <p class="bottom-text-drafts">Robocze: {{ buildingData.draft_a_declarations_count }}</p>
        <p class="bottom-text-published">Złożone: {{ buildingData.submitted_a_declarations_count }}</p>
      </div>
      <div class="bottom-text">
        <div class="letter-icon second-icon">B</div>
        <p class="bottom-text-title">Budynek / lokal niemieszkalny</p>
        <p class="bottom-text-drafts">Robocze: {{ buildingData.draft_b_declarations_count }}</p>
        <p class="bottom-text-published">Złożone: {{ buildingData.submitted_b_declarations_count }}</p>
      </div>

    </div>
  </div>
</template>

<script>


export default {
  name: "BuildingCard",
  data() {
    return {
      showDropdown: false
    }
  },
  props: {
    // "id": 85,
    // "city": {"id": 191585, "name": "Dzierżoniów", "has_no_streets": false, "community": 3374},
    // "street": {"id": 5074, "name": "ul. Wesoła", "city": 191585},
    // "community": {"id": 3374, "name": "Dzierżoniów - gmina miejska", "county": 522},
    // "county": {"id": 522, "name": "dzierżoniowski", "voivodeship": 25},
    // "voivodeship": {"id": 25, "name": "DOLNOŚLĄSKIE"},
    // "number": "2",
    // "custom_street_name": "",
    // "postal_code": "00-000",
    // "house_number": null,
    // "user": 4
    buildingData: {
      type: Object,
      required: true
    }
  },
  methods: {
    openEditBuildingModal() {
      this.$store.commit("setBuildingToEdit", this.buildingData);
      this.$store.commit("openBuildingsModal");
    },
    openDeclarationModal(type) {
      const data = this.buildingData;
      data.declarationType = type;
      this.$store.commit("setDeclarationBuilding", data);
      this.$store.commit("openDeclarationModal");
    },
    openDeleteModal() {
      if (this.anyDeclarationWasAdded(this.buildingData)) {
        this.$store.commit("setDeleteBuildingData", {allowed: false});
        this.$bvModal.show('delete-building-modal');
        return;
      }
      const data = {id: this.buildingData.id, info: `${this.street} ${this.number}`, allowed: true};
      this.$store.commit("setDeleteBuildingData", data);
      this.$bvModal.show('delete-building-modal');
    },
    anyDeclarationWasAdded(buildingData) {
      return buildingData.draft_a_declarations_count > 0 ||
          buildingData.submitted_a_declarations_count > 0 ||
          buildingData.draft_b_declarations_count > 0 ||
          buildingData.submitted_b_declarations_count > 0;
    }
  },
  computed: {
    street() {
      let result = "";
      if (this.buildingData.street) {
        result = this.buildingData.street.name;
      } else {
        let customStreetName = this.buildingData.custom_street_name;
        result = customStreetName.length ? `ul. ${customStreetName}` : customStreetName;
      }
      if (result.length >= 20) {
        result = `${result.substr(0, 20)}...`;
      }
      return result;
    },
    number() {
      return this.buildingData.number ? this.buildingData.number.name : this.buildingData.custom_number;
    }
  }
}
</script>

<style scoped>
.dropdown-item-zone {
  padding: .1rem 0 !important;
}

.card:hover {
  border: 1px dotted #4D4D4D;
}

.card {
  border: none;
  width: 16.5rem;
  box-shadow: 2px 2px 10px 4px #0000001a;
  height: 21.9rem;
  margin-left: 2.5rem;
  border-radius: .3rem;
  margin-bottom: 2rem;
}

.card-header {
  height: 4.4rem;
  display: grid;
  grid-template-columns: 85% 5%;
  font-weight: bold;
  padding: 1.3rem 1rem;
  line-height: 0.5rem;
  color: #202f64;
}

.card-title {
  grid-column-start: -3;
  grid-column-end: -2;
}

.card-body {
  width: 101%;
  padding: 0;
}

.card-image {
  width: 99%;
}

.bottom-text {
  width: 100%;
  height: 3rem;
  display: grid;
  grid-template-columns: 20% 30% 50%;
  grid-template-rows: 50% 50%;
  padding: 5px;
  color: #1e2e68;
}

.letter-icon {
  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 1;
  grid-row-end: 3;
  margin: auto;
  width: 2rem;
  height: 2rem;
  font-size: 1.5rem;
  font-weight: bold;
  vertical-align: middle;
  padding-left: 0.45rem;
}

.first-icon {
  background-color: #1e2e68;
  color: #fbbe03;
}

.second-icon {
  color: #1e2e68;
  background-color: #fbbe03;
}

.bottom-text-title {
  font-size: .8rem;
  font-weight: bold;
  grid-column-start: 2;
  grid-column-end: 4;
  grid-row-start: 1;
  grid-row-end: 2;
}

.bottom-text-drafts {
  grid-column-start: 2;
  grid-column-end: 3;
  grid-row-start: 2;
  grid-row-end: 3;
  font-size: 0.8rem;
}

.bottom-text-published {
  grid-column-start: 3;
  grid-column-end: 4;
  grid-row-start: 2;
  grid-row-end: 3;
  font-size: 0.8rem;
}

.building-type-label {
  padding: 0 0 0 1rem;
  margin-bottom: 0;
  color: #1e2e68;
  margin-top: -1.5rem;
}

.card-menu {
  font-size: 1.3rem;
  cursor: pointer;
  grid-column-start: -2;
  grid-column-end: -1;
  margin-top: -.5rem;
}
</style>
